import { render, staticRenderFns } from "./cima_section.vue?vue&type=template&id=4598a290&scoped=true"
import script from "./cima_section.vue?vue&type=script&lang=js"
export * from "./cima_section.vue?vue&type=script&lang=js"
import style0 from "./cima_section.vue?vue&type=style&index=0&id=4598a290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598a290",
  null
  
)

export default component.exports